import { h } from 'preact';

export const powsterHeaderLogo = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 17">
		<path d="M49.22 1.1l-3.46 10.29-3.46-10.3h-3.07l-3.46 10.3-3.46-10.3h-3.07l5 14.87h3.07l3.45-10.29 3.46 10.3h3.08l5-14.87zM18.14 8.53L15.66 1.1H5.2l-1 2.97h9.38l.94 2.8-6.54 2.05-2.6 4.34H4.2l2.4-7.15-2.78-.87-3.6 10.72h6.64L9.7 11.2zM74.09 1.1H61.8v2.97h4.6v11.9h3.08V4.06h4.6zm11.7 2.97V1.1H75.8V15.96h9.99V13h-6.92v-2.97h5.38V7.04h-5.38V4.07zm-28.1 3.7a7.8 7.8 0 012.83 1.33c.65.58 1 1.46 1 2.57 0 1.1-.51 2.53-1.37 3.21a5.26 5.26 0 01-3.38 1.05l-7.55.04 1-2.98h6.64c.4.03.79-.09 1.1-.33.3-.2.48-.55.49-.9a1.1 1.1 0 00-.48-.93c-.32-.22-.81-.41-1.73-.7l-4.57-1.44.85-2.54 5.18 1.63zm2.48-3.7h-6.95l1-2.97h5.95z"/>
		<path d="M21.59.93c-1.18 0-2.34.26-3.4.75l.95 2.88a4.87 4.87 0 016.53 1.6c1.36 2.17.64 5-1.6 6.32a4.88 4.88 0 01-6.55-1.5l-2.97.94a7.96 7.96 0 009.41 3.85 7.59 7.59 0 005.38-8.4A7.78 7.78 0 0021.58.94zm80.08 7.6L99.18 1.1H87.5v14.86h3.07v-3.92l5.58-1.76 1.91 5.7h3.06L98.9 9.4l2.76-.88zm-11.11.69V4.07h6.56l.94 2.8-7.5 2.35z"/>
	</svg>
);

export const socialIcons = {
	facebook: (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 22">
			<path fill-rule="evenodd" d="M7.56 4.12H11V0H7.56a4.82 4.82 0 00-4.8 4.8v2.08H0V11h2.75v11h4.13V11h3.44L11 6.88H6.88V4.8a.7.7 0 01.68-.69z"/>
		</svg>
	),
	instagram: (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
			<path fill-rule="evenodd" d="M10.94 5.07c3.4 0 6.16 2.78 6.16 6.2s-2.76 6.22-6.16 6.22c-3.4 0-6.16-2.78-6.16-6.21s2.76-6.21 6.16-6.21zM6.34 0h9.31C19.15 0 22 2.85 22 6.32v9.36A6.35 6.35 0 0115.65 22h-9.3A6.35 6.35 0 010 15.68V6.32A6.35 6.35 0 016.35 0zM16.9 4.2a1 1 0 011 1.01 1 1 0 11-2 0 1 1 0 011-1.01zM7.11 1.8h7.78c2.92 0 5.3 2.39 5.3 5.33v7.89a5.33 5.33 0 01-5.3 5.33H7.1a5.33 5.33 0 01-5.3-5.33v-7.9A5.33 5.33 0 017.1 1.8zm3.83 5.35a4.1 4.1 0 014.07 4.1 4.1 4.1 0 01-4.07 4.1 4.08 4.08 0 01-4.07-4.1 4.1 4.1 0 014.07-4.1z"/>
		</svg>
	),
	twitter: (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 20">
			<path fill-rule="evenodd" d="M22.99 2.37c-.85.41-1.75.67-2.7.8a5.03 5.03 0 002.07-2.8c-.91.58-1.92 1-3 1.22A4.57 4.57 0 0015.93 0c-2.61 0-4.72 2.25-4.72 5.05 0 .4.04.78.12 1.15A13.12 13.12 0 011.6.92a5.4 5.4 0 00-.63 2.54c0 1.75.83 3.3 2.1 4.2a4.6 4.6 0 01-2.14-.63v.06a4.99 4.99 0 003.79 4.95 4.47 4.47 0 01-2.13.1 4.8 4.8 0 004.4 3.5A9.03 9.03 0 010 17.75 12.77 12.77 0 007.24 20c8.67 0 13.43-7.69 13.43-14.37 0-.23 0-.44-.02-.65A9.52 9.52 0 0023 2.37h-.01z"/>
		</svg>
	),
	linkedin: (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path fill-rule="nonzero" d="M6.735 4.875a1.867 1.867 0 0 1-1.86 1.875c-1.027 0-1.86-.84-1.86-1.875C3.015 3.84 3.848 3 4.875 3c1.027 0 1.86.84 1.86 1.875ZM6.75 8.25H3v12h3.75v-12Zm5.986 0H9.01v12h3.727v-6.3c0-3.502 4.522-3.788 4.522 0v6.3H21v-7.598c0-5.91-6.691-5.695-8.264-2.786V8.25Z"/>
		</svg>
	)
};

export const mailIcon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  	<path d="M2 5v14h20V5H2zm18 12H4V9.42l8 4.619 8-4.619V17zM4.059 7h15.883L12 11.585 4.059 7z" id="mail"/>
	</svg>
);

export const largeArrow = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
		<path d="M20.71 0v37.718L5.795 27.361l-3.786 5.363L24.007 48l22.002-15.276-3.786-5.363L27.31 37.718V0z" />
	</svg>
);

export const chevron = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<path d="M20.28 7.27L12 13.068 3.72 7.27 2 9.728l10 7.002 10-7.002z" id="chevron"/>
	</svg>
);

export const arrowOutline = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57">
		<path d="M2 22.903v10.6h35.894l-9.308 13.404L37.216 53l17.219-24.795L37.217 3.407 28.587 9.5l9.306 13.404L2 22.903zm2 2h37.718L31.36 9.99l5.363-3.786 15.276 22-15.276 22-5.363-3.786 10.357-14.916H4v-6.6z" fill="#FFF" fill-rule="nonzero"/>
	</svg>
);

export const visitArrow = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	  <path d="M10 20H3V4h7v2h3V1H0v22h13v-5h-3v2z"/>
	  <path d="M18.098 5l-1.72 1.204 3.323 4.746H9v2.1h10.701l-3.323 4.745L18.098 19 23 12l-4.902-7z"/>
	</svg>
);

export const copy = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  	<path d="M16 7V0H2v18h6v6h14V7h-6zM5 15V3h8v4H8v8H5zm14 6h-8V10h8v11z" />
	</svg>
);

export const newsletter = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" role='img'>
		<path d="M23.775 10.526V5.101a1 1 0 00-1-1H8.301a1 1 0 00-1 1v5.425l-3.328 2.277a1.001 1.001 0 00-.435.825v13.473a1 1 0 001 1h22a1 1 0 001-1V13.628a1 1 0 00-.436-.825l-3.327-2.277zM8.301 5.101h14.474v11.175l-7.237 4.825-7.237-4.825V5.101zm-1 6.491v4.018l-3.013-2.009 3.013-2.009zm19.237 15.509h-22V14.97l10.445 6.963.555.37.555-.37 10.445-6.963v12.131zM23.775 15.61v-4.018l3.013 2.009-3.013 2.009zM10.538 8.101h10v-1h-10v1zm0 3h10v-1h-10v1zm0 3h5v-1h-5v1z" fill-rule="evenodd" clip-rule="evenodd" />
	</svg>
);

export const close = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
		<path d="M12.575 2L8 6.574 3.426 2 2 3.426 6.574 8 2 12.575l1.426 1.426L8 9.427l4.575 4.574L14 12.575 9.426 8 14 3.426z" fill-rule="nonzero"/>
	</svg>
);
